import * as Styled from './styles';

type AppTableProps = {
  tableItems: (string | number)[][];
  className?: string;
  reversed?: boolean;
  plain?: boolean;
  noPadding?: boolean;
};

export const AppTable = ({
  tableItems,
  className,
  reversed,
  plain,
  noPadding
}: AppTableProps): JSX.Element => {
  return (
    <Styled.Table
      className={className}
      $reversed={reversed}
      $plain={plain}
      $noPadding={noPadding}
    >
      {tableItems.map(row => {
        const [caption, price] = row;
        return (
          <div key={caption}>
            <p>{caption}</p>
            <p>{price}</p>
          </div>
        );
      })}
    </Styled.Table>
  );
};
